// =============================================================================
// FILE PATH: src/modules/pms/components/WBSNodeRow.js
// =============================================================================

import React from "react";

export default function WBSNodeRow({
  node,
  level,

  // 🔥 NEW
  wbsCode,

  onAdd,
  onDependency,
  onEdit,
  onDelete,
  onSelect,
  selectedNode,
  predecessorMap = {},
  successorMap = {},
  canAddChild = false,
 isExpanded = false,
hasChildren = false,
onToggleExpand
}) {

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const parts = dateStr.split("-");
    if (parts.length !== 3) return dateStr;

    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  // 🔥 RESOLVE DEPENDENCIES
  const predecessors = predecessorMap[node.id] || [];
  const successors = successorMap[node.id] || [];

  // ---------------------------------------------------------------------------
  // NODE TYPE CONFIG
  // ---------------------------------------------------------------------------
  const getNodeConfig = () => {

    switch (node.type) {

      case "ITEM":
        return {
          icon: "📦",
          badgeStyle: styles.typeBadgeItem
        };

      case "PHASE":
        return {
          icon: "📁",
          badgeStyle: styles.typeBadgePhase
        };

      case "TASK":
      default:
        return {
          icon: "📄",
          badgeStyle: styles.typeBadgeTask
        };
    }
  };

  const nodeConfig = getNodeConfig();

  return (
    <div
      style={{
        ...styles.row,
        backgroundColor:
          selectedNode?.id === node.id
            ? "#e3f2fd"
            : "#fff"
      }}
      onClick={() => onSelect && onSelect(node)}
    >

      {/* WBS CODE */}
      <div style={styles.colWbs}>
        {wbsCode}
      </div>

      {/* WBS ID */}
      <div style={styles.colId}>
        {node.id}
      </div>

      {/* NAME */}
      <div
        style={{
          ...styles.colName,
          paddingLeft: level * 20
        }}
      >

        {/* EXPAND / COLLAPSE */}
        <span
          style={styles.expandIcon}
          onClick={(e) => {
            e.stopPropagation();

            if (hasChildren && onToggleExpand) {
              onToggleExpand(node.id);
            }
          }}
        >
          {hasChildren
            ? (isExpanded ? "▼" : "▶")
            : "•"}
        </span>

        <span style={styles.icon}>
          {nodeConfig.icon}
        </span>

        <span style={styles.nameText}>
          {node.name}
        </span>

      </div>

      {/* TYPE */}
      <div style={styles.colType}>

        <span style={nodeConfig.badgeStyle}>
          {node.type}
        </span>

      </div>

      {/* ASSIGNED */}
      <div style={styles.colAssigned}>
        {node.assigned_name
          ? `${node.assigned_name} (${node.assigned_role})`
          : "-"}
      </div>

      {/* START */}
      <div style={styles.colStart}>
        {formatDate(node.planned_start)}
      </div>

      {/* END */}
      <div style={styles.colEnd}>
        {formatDate(node.planned_end)}
      </div>

      {/* PREDECESSOR */}
      <div style={styles.colPredecessor}>
        {predecessors.length > 0
          ? predecessors.join(", ")
          : "-"}
      </div>

      {/* SUCCESSOR */}
      <div style={styles.colSuccessor}>
        {successors.length > 0
          ? successors.join(", ")
          : "-"}
      </div>

      {/* STATUS */}
      <div style={styles.colStatus}>
        <span style={getStatusStyle(node.status_code)}>
          {node.status_code}
        </span>
      </div>

      {/* ACTIONS */}
      <div style={styles.colActions}>

        {/* ADD CHILD */}
        {canAddChild && (
          <button
            style={styles.actionPrimary}
            title="Add Child"
            onClick={(e) => {
              e.stopPropagation();
              onAdd(node.id);
            }}
          >
            +
          </button>
        )}

        {/* DEPENDENCY */}
        {node.type === "TASK" && (
          <button
            style={styles.actionDependency}
            title="Add Dependency"
            onClick={(e) => {
              e.stopPropagation();

              onDependency &&
              onDependency(node);
            }}
          >
            🔗
          </button>
        )}

        {/* EDIT */}
        <button
          style={styles.actionSecondary}
          title="Edit"
          onClick={(e) => {
            e.stopPropagation();

            onEdit &&
            onEdit(node);
          }}
        >
          ✏️
        </button>

        {/* DELETE */}
        <button
          style={styles.actionDanger}
          title="Delete"
          onClick={(e) => {
            e.stopPropagation();

            onDelete &&
            onDelete(node);
          }}
        >
          ✖
        </button>

      </div>

    </div>
  );
}

// -----------------------------------------------------------------------------
// STATUS STYLE
// -----------------------------------------------------------------------------
function getStatusStyle(status) {

  switch (status) {

    case "COMPLETED":
      return styles.statusGreen;

    case "IN_PROGRESS":
      return styles.statusBlue;

    default:
      return styles.statusGray;
  }
}

// -----------------------------------------------------------------------------
// STYLES
// -----------------------------------------------------------------------------
const styles = {

  row: {
    display: "flex",
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    alignItems: "center",
    background: "#fff",
    transition: "all 0.2s",
    cursor: "default"
  },

  rowHover: {
    background: "#f9fafb"
  },

  // 🔥 NEW
  colWbs: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 600,
    color: "#374151"
  },

  colId: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    color: "#6b7280"
  },

  colName: {
    flex: 3,
    display: "flex",
    alignItems: "center",
    gap: 8
  },

  colType: {
    flex: 1,
    textAlign: "center"
  },

  colAssigned: {
    flex: 2,
    textAlign: "center",
    fontSize: 13,
    color: "#374151"
  },

  colStart: {
    flex: 2,
    textAlign: "center",
    fontSize: 13,
    color: "#374151"
  },

  colEnd: {
    flex: 2,
    textAlign: "center",
    fontSize: 13,
    color: "#374151"
  },

  colPredecessor: {
    flex: 2,
    textAlign: "center",
    fontSize: 12
  },

  colSuccessor: {
    flex: 2,
    textAlign: "center",
    fontSize: 12
  },

  colStatus: {
    flex: 2,
    textAlign: "center"
  },

  colActions: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    gap: 6
  },

  nameText: {
    fontSize: 14,
    fontWeight: 500
  },

  icon: {
    fontSize: 15
  },
  expandIcon: {
  width: 16,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  color: "#4b5563",
  fontSize: 11,
  userSelect: "none"
},

  // ---------------------------------------------------------------------------
  // TYPE BADGES
  // ---------------------------------------------------------------------------
  typeBadgeItem: {
    fontSize: 11,
    padding: "3px 8px",
    borderRadius: 10,
    background: "#fef3c7",
    color: "#b45309",
    fontWeight: 600
  },

  typeBadgePhase: {
    fontSize: 11,
    padding: "3px 8px",
    borderRadius: 10,
    background: "#eef2ff",
    color: "#4f46e5",
    fontWeight: 600
  },

  typeBadgeTask: {
    fontSize: 11,
    padding: "3px 8px",
    borderRadius: 10,
    background: "#f3f4f6",
    color: "#374151",
    fontWeight: 600
  },

  // ---------------------------------------------------------------------------
  // ACTION BUTTONS
  // ---------------------------------------------------------------------------
  actionPrimary: {
    background: "#4f46e5",
    color: "#fff",
    border: "none",
    width: 26,
    height: 26,
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14
  },

  actionDependency: {
    background: "#fde68a",
    border: "none",
    width: 26,
    height: 26,
    borderRadius: 6,
    cursor: "pointer"
  },

  actionSecondary: {
    background: "#e5e7eb",
    border: "none",
    width: 26,
    height: 26,
    borderRadius: 6,
    cursor: "pointer"
  },

  actionDanger: {
    background: "#fee2e2",
    border: "none",
    width: 26,
    height: 26,
    borderRadius: 6,
    cursor: "pointer"
  },

  // ---------------------------------------------------------------------------
  // STATUS
  // ---------------------------------------------------------------------------
  statusGray: {
    background: "#f3f4f6",
    color: "#374151",
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 500,
    display: "inline-block",
    minWidth: 80,
    textAlign: "center"
  },

  statusBlue: {
    background: "#dbeafe",
    color: "#1d4ed8",
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 500,
    display: "inline-block",
    minWidth: 80,
    textAlign: "center"
  },

  statusGreen: {
    background: "#dcfce7",
    color: "#15803d",
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 500,
    display: "inline-block",
    minWidth: 80,
    textAlign: "center"
  }
};